import { request } from '@/lib/apiClient'

export type ChatMessage = { id: string; author: 'CUSTOMER' | 'SUPPORT'; body: string; createdAt: string }
export type ChatThread = { conversationId: string | null; status: 'OPEN' | 'CLOSED' | null; messages: ChatMessage[] }
export type ChatStarted = { token: string; conversationId: string; messages: ChatMessage[] }

/** The visitor's session travels in its own header; the account's chat uses the session's bearer as any other call. */
const sessionHeader = (token: string) => ({ 'X-Support-Session': token })

export const supportChatApi = {
  start: (message: string, clientMessageId: string) =>
    request<ChatStarted>('/support/chat/sessions', { method: 'POST', body: { message, clientMessageId } }),
  send: (conversationId: string, token: string, message: string, clientMessageId: string) =>
    request<ChatThread>(`/support/chat/sessions/${conversationId}/messages`, { method: 'POST', body: { message, clientMessageId }, headers: sessionHeader(token) }),
  read: (conversationId: string, token: string, after?: string) =>
    request<ChatThread>(`/support/chat/sessions/${conversationId}/messages`, { method: 'GET', params: { after }, headers: sessionHeader(token) }),
  mine: () => request<ChatThread>('/support/chat/me', { method: 'GET' }),
  sendMine: (message: string, clientMessageId: string) =>
    request<ChatThread>('/support/chat/me/messages', { method: 'POST', body: { message, clientMessageId } }),
  claim: (token: string) => request<ChatThread>('/support/chat/me/claim', { method: 'POST', body: { token } }),
}
